import { providerHandler } from '@blaze-cms/core-auth-ui';
import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { getCookieMiddleware, requestContextEventHandler } from './utils';
import components from './components';
async function load(app, {
  authProviderOrder
} = {}) {
  if (authProviderOrder) providerHandler.setProviderOrder(authProviderOrder);
  app.addMiddleware(getCookieMiddleware(app));
  if (!providerHandler.setupComplete) {
    app.events.once('plugin:page-builder-fe:load:loaded', async () => {
      await app.events.emitAsync('plugin:auth-fe:load:auth-providers', providerHandler.add);
      providerHandler.setupComplete = true;
    });
  }
  app.events.once('load:custom:page-builder:component', addComponent => {
    Object.entries(components).forEach(([key, component]) => addComponent({
      key,
      component
    }));
  });
  app.events.on('page-load:get-initial-props:before', requestContextEventHandler);
  return {
    name: PLUGIN_NAME,
    version: pkg.version,
    authProviderHandler: providerHandler
  };
}
load.pluginName = PLUGIN_NAME;
export default load;
//# sourceMappingURL=index.js.map